import type { EntityOption } from '@/components/EntitySelect';
import { createDepartment, getDepartment, listDepartments } from './api';

/** Server search for the department picker (EntitySelect). */
export async function searchDepartments(query: string): Promise<EntityOption[]> {
  const results = await listDepartments(query || undefined);
  return results.map((d) => ({ value: String(d.id), label: d.name }));
}

/** Inline-create a department from the picker (EntitySelect `onCreate`). */
export async function createDepartmentOption(name: string): Promise<EntityOption> {
  const dept = await createDepartment({ name: name.trim() });
  return { value: String(dept.id), label: dept.name };
}

/** Resolve a department's name for a preselected id (edit mode). */
export async function resolveDepartmentLabel(value: string): Promise<string | null> {
  if (!value) return null;
  const dept = await getDepartment(Number(value));
  return dept.name;
}
